<template>
  <div
    class="my-9 flex flex-col-reverse flex-wrap gap-6 lg:flex-row lg:justify-between"
  >
    <form class="w-fit" @submit.prevent="onSearch">
      <UiInput
        v-model="search"
        type="text"
        input-classes="w-90 lg:w-50 pl-9 py-2.5 pr-2.5 font-light"
        :placeholder="$t('search')"
        prepend-icon="search"
      />
    </form>
    <ul v-if="categoriesDataAll?.length > 1" class="flex gap-4">
      <li
        v-for="item in categoriesDataAll"
        :key="item.slug"
        class="m-0 flex list-none flex-wrap items-center gap-4 rounded-[50px] px-0 max-lg:hidden"
        :class="{
          'bg-sand-50/50':
            route.params.section === item.slug ||
            (item.slug === 'all' && !route.params.section),
        }"
      >
        <UiButton
          :to="item.slug === 'all' ? '/blog#list' : `/blog/${item?.slug}#list`"
          :variant="'outlined'"
          :content-class="'text-gray-90 ui-text-sm normal-case'"
        >
          {{ item?.currentTranslation?.title }}
        </UiButton>
      </li>
      <li class="lg:!hidden">
        <UiScrollableSlider
          :items-list="categoriesDataAll"
          :slides-count="'auto'"
          :list-classes="'max-sm:w-[calc(100vw-32px)] max-lg:w-[calc(90vw-32px)]'"
          :item-classes="'first:ml-0 last:mr-0'"
          :gap-x="15"
        >
          <template #card="{ item }">
            <UiButton
              :to="
                item.slug === 'all' ? '/blog#list' : `/blog/${item?.slug}#list`
              "
              :variant="'outlined'"
              :content-class="'text-gray-90 ui-text-sm normal-case'"
              class="flex h-10 items-center justify-center rounded-[50px] border border-gray-90 px-4.5 py-3"
              :class="{
                'bg-sand-50/50':
                  route.params.section === item.slug ||
                  (item.slug === 'all' && !route.params.section),
              }"
            >
              {{ item?.currentTranslation?.title }}
            </UiButton>
          </template>
        </UiScrollableSlider>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { BlogCategory } from "ecom-types";

const props = defineProps<{
  categoriesData: BlogCategory[];
}>();

const route = useRoute();
const router = useRouter();
const localePath = useLocalePathPolyfill();
const { t } = useI18n();
const search = ref(route.query.search || "");

const categoriesDataAll = computed(() => {
  const allLink: Partial<BlogCategory> = {
    id: "all-link",
    slug: "all",
    currentTranslation: { title: t("all") },
    sort_order: -1,
  };

  return [allLink, ...props.categoriesData.filter((el) => el.status)];
});

function onSearch() {
  const path = `/blog?search=${search.value}#list`;
  const localizedPath = localePath(path);
  router.push(localizedPath);
}
</script>
